import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {FieldTypeKind} from '../enum/field.type.kind';

@EntityTable('database_seed', 'dbfc62dc-40d1-4290-8fd1-f54e15ff210b')
export class DbSeedEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public author: string;

    @Column(FieldTypeKind.STRING)
    public md5: string;

    @Transient()
    public data: any[];

}
